import type { RowValue } from "../../../../../../lib/csv";
import parseCSV, { getHeaders } from "../../../../../../lib/csv";
import { expectedColumns } from "./FilesType";

const getStringToRegex = (key: string) => {
  let regexString = key;
  if (key.includes("*")) {
    regexString = regexString.replaceAll("*", "\\d+");
  }
  return new RegExp(`^${regexString}$`);
};

export function findUnkownColumns(content: string | RowValue, mandatoryColumns: readonly string[]) {
  const headers = typeof content === "string" ? getHeaders(content) : Object.keys(content);
  if (!headers) return [];

  return headers.filter(header => {
    const isMandatory = mandatoryColumns.some(mandatory => {
      const regex = getStringToRegex(mandatory);
      return regex.test(header) || header === mandatory;
    });
    return !isMandatory;
  });
}

export async function checkAndParseContent(file: File) {
  const csv = await file.text();

  const csvParsed: RowValue[] = parseCSV(csv, "line");

  const linesParsed: RowValue[] = [];
  // Line CSV
  for (const line of csvParsed) {
    const lineParsed: RowValue = line;
    const namesImpacts = findUnkownColumns(line, expectedColumns);
    lineParsed["impacts"] = namesImpacts.join(",") ?? null;
    for (const nameImpact of namesImpacts) {
      lineParsed[nameImpact] = line[nameImpact] ?? null;
    }
    linesParsed.push(lineParsed);
  }

  return {
    fileName: file.name,
    content: linesParsed,
  };
}
